import { Avatar } from "@mui/material";

type InitialsAvatarProps = { fullName: string };

function stringToHash(string: string) {
  return string.split("").reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
}

function stringAvatarProps(name: string) {
  const parts = name.split(" ");
  const firstName = parts[0] || "";
  const lastName = parts.at(-1) || "";
  const initials =
    parts.length <= 1 ? firstName.charAt(0) : `${firstName.charAt(0)}${lastName.charAt(0)}`;

  return {
    sx: {
      color: "white",
      bgcolor: `hsl(${stringToHash(name) % 360}, 60%, 45%)`,
    },
    children: initials.toUpperCase(),
  };
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ fullName }) => {
  return <Avatar {...stringAvatarProps(fullName)} />;
};

export default InitialsAvatar;
